<!-- 
  TODO: think about resolving redundancies if needed between this & @\components\SlideEditor\TopHigherHorizontalBar — N36G3WBi
-->

<template>
<div class="top-bars">
  <div class="top-higher-horizontal-bar justify-between flex-wrap">
    <div class="flex flex-row items-center gap-2">
      <div class="component-title">
        Live Stream Editor
      </div>
      <ReloadButton 
        tooltipText="Reload Player Subscription"
        :isLoading="isLoading"
        :reloadHandler="reloadPlayerSubscription"
      />
      <ButtonCustomized
        :label="(isLiveStreamStarted ? '⏹ &nbsp; Stop Stream' : '▶ &nbsp; Start Stream')"
        :secondary="isLiveStreamStarted"
        @click="toggleLiveStream"
        class="collapsible-button ml-4"
      />
    </div>
  </div>
  <PageSection>
    <div class="top-lower-horizontal-bar">
      <div class="main-fields">
        <ResponsiveTable>
          <!-- Name -->
          <Cell width="20%" class="flex items-center"><LabelCustomized label="Name" required /></Cell>
          <Cell width="80%" class="flex items-center"><TextField v-model="data.name" :required="true" width="40ch" /></Cell>

          <!-- Description -->
          <Cell width="20%"><LabelCustomized label="Description" /></Cell>
          <Cell width="80%"><TextField multiline v-model="data.description" /></Cell>

          <!-- Is Active -->
          <Cell>
            <CheckBoxField
              v-model="data.isActive"
              label="Active"
              name="active"
              :suffix-label="false"
              :label-with-margin="false"
            />
          </Cell>
        </ResponsiveTable>
      </div>
      <!-- TODO: consider adding Create another player subscription button if needed -->
    </div>
  </PageSection>
  </div>
</template>

<script lang="ts" setup>
import PageSection from '@/components/layouts/PageSection.vue';
import ReloadButton from '@/components/ReloadButton/ReloadButton.vue';
import TextField from '@/components/form-fields/TextField.vue';
import CheckBoxField from "@/components/form-fields/CheckboxField.vue";
import { useLiveStream } from '../composables/liveStream';
import { ResponsiveTable } from '@/components/ResponsiveTable';
import Cell from '@/components/ResponsiveTable/Cell.vue';
import LabelCustomized from '@/components/form-fields/LabelCustomized/LabelCustomized.vue';
import ButtonCustomized from '@/components/form-fields/ButtonCustomized.vue';
import sharedRefs from '../sharedRefs';
import { computed } from 'vue';

const {
  data,
  reloadPlayerSubscription,
  isLoading
} = useLiveStream();

const { saveSubscriptionButtonRef, isStartStream } = sharedRefs;

const isLiveStreamStarted = computed(() => {
  return isStartStream.value;
});

function toggleLiveStream() {
  isStartStream.value = !isStartStream.value;
  saveSubscriptionButtonRef.value.saveLiveStream(isStartStream.value ? "start" : "stop");
}
</script>

<style lang="scss" scoped>
.component-title {
  color: #25294A;
  font-size: 32px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.top-higher-horizontal-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.top-lower-horizontal-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 2rem;

  .main-fields {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    max-width: 28.125rem;
    :deep(.Rtable) {
      margin: 0;
    }
  }
}
</style>